import {
    BAZAAR_PRODUCT_COMPLAINT_TITLE,
    FORUM_COMMENT_DOES_NOT_BELONG_TO_FORUM,
    IMAGE_DOES_NOT_BELONG_TO_PHOTOBLOG,
    MESSAGE_DOES_NOT_BELONG_TO_FORUM,
    PHOTOBLOG_COMMENT_DOES_NOT_BELONG_TO_PHOTOBLOG,
    PHOTOBLOG_POST_DOES_NOT_BELONG_TO_PHOTOBLOG,
} from 'mk/autogenerated/translations/Complaint.constants.0695a04b796c65e3ff57e5969cb78dc7'
import { ComplaintTargetType } from 'mk2/containers/Complaint/Complaint.schemas';

export const TITLES = {
    [ComplaintTargetType.ForumMessage]: FORUM_COMMENT_DOES_NOT_BELONG_TO_FORUM,
    [ComplaintTargetType.ForumThread]: MESSAGE_DOES_NOT_BELONG_TO_FORUM,
    [ComplaintTargetType.PhotoblogComment]: PHOTOBLOG_COMMENT_DOES_NOT_BELONG_TO_PHOTOBLOG,
    [ComplaintTargetType.PhotoblogImage]: IMAGE_DOES_NOT_BELONG_TO_PHOTOBLOG,
    [ComplaintTargetType.PhotoblogPost]: PHOTOBLOG_POST_DOES_NOT_BELONG_TO_PHOTOBLOG,
    [ComplaintTargetType.BazaarProduct]: BAZAAR_PRODUCT_COMPLAINT_TITLE,
};
